module.exports = __webpack_public_path__ + "img/submit_docs.5f0dc7f1.png";